/* KUVAIA launch theme: interactions for the V7 design sections. */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) {
    var v = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    return '£' + v;
  };
  var pairsOf = function (title) { var n = parseInt(String(title), 10); return n > 0 ? n : 1; };
  var planShort = function (name) { return String(name || '').replace(', 15% off', '').replace(/^Deliver /, ''); };
  var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };

  /* ---------------------------------------------------------- product data */
  var product = null;
  var pj = document.querySelector('[data-kv-product]');
  if (pj) { try { product = JSON.parse(pj.textContent); } catch (e) { product = null; } }

  /* ---------------------------------------------------------- cart */
  var drawerOpen = function () {
    var c = document.getElementById('kv-cart');
    if (!c) { window.location.href = '/cart'; return; }
    c.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };
  var drawerClose = function () {
    var c = document.getElementById('kv-cart');
    if (!c) return;
    if (document.body.classList.contains('template-cart')) { window.location.href = (product && product.url) || '/'; return; }
    c.hidden = true;
    document.documentElement.style.overflow = '';
  };
  var refreshCart = function (open) {
    var was = document.getElementById('kv-cart');
    var keep = !!(was && !was.hidden);
    var sc = was ? (was.querySelector('.kxr') || was.querySelector('.kxl') || null) : null;
    var top = sc ? sc.scrollTop : 0;
    return fetch('/?sections=kv-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var wrap = document.getElementById('shopify-section-kv-cart-drawer');
        if (wrap && j['kv-cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = j['kv-cart-drawer'];
          var inner = tmp.querySelector('#shopify-section-kv-cart-drawer') || tmp;
          wrap.innerHTML = inner.innerHTML;
          var now = document.getElementById('kv-cart');
          if (now && keep) {
            now.hidden = false;
            var sc2 = now.querySelector('.kxr') || now.querySelector('.kxl');
            if (sc2) sc2.scrollTop = top;
          }
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-kv-v="bag"]').forEach(function (el) { el.textContent = cart.item_count; });
        if (open) drawerOpen();
      });
  };
  var post = function (url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; });
    });
  };
  var addItem = function (id, plan, qty) {
    var item = { id: id, quantity: qty || 1 };
    if (plan) item.selling_plan = plan;
    return post('/cart/add.js', { items: [item] });
  };
  var busy = function (el, on) { if (el) el.classList.toggle('kv-busy', !!on); };

  /* ---------------------------------------------------------- buy box state per root */
  var BUY = new WeakMap();
  var SHARED = {};
  var buyKey = function (root) { return root && root.getAttribute ? root.getAttribute('data-kv-buy') : null; };
  var buyState = function (root) {
    var key = buyKey(root);
    if (key) {
      if (!SHARED[key]) { var nn = product ? product.variants.length : 0; SHARED[key] = { vi: 0, sub: root.getAttribute('data-kv-mode') === 'sub', plan: 0, last: Math.max(0, nn - 1) }; }
      return SHARED[key];
    }
    if (!BUY.has(root)) {
      var n = product ? product.variants.length : 0;
      BUY.set(root, { vi: 0, sub: root.getAttribute('data-kv-mode') === 'sub', plan: 0, last: Math.max(0, n - 1) });
    }
    return BUY.get(root);
  };
  var allocFor = function (v, planIdx) {
    var a = (v && v.selling_plan_allocations) || [];
    return a[planIdx] || a[0] || null;
  };
  var planList = function () {
    if (!product || !product.selling_plan_groups || !product.selling_plan_groups.length) return [];
    return product.selling_plan_groups[0].selling_plans || [];
  };
  var buyVals = function (st) {
    var v = product.variants[st.vi];
    var last = product.variants[st.last];
    var la = allocFor(last, st.plan);
    var sub = st.sub && st.vi === st.last && la;
    var price = sub ? la.price : v.price;
    var pairs = pairsOf(v.title);
    var plans = planList();
    var p = la ? plans.filter(function (x) { return x.id === la.selling_plan_id; })[0] || plans[st.plan] || null : plans[st.plan] || null;
    var months = p ? (parseInt((p.name.match(/(\d+)\s*month/) || [])[1], 10) || 1) : 1;
    var subp = la ? la.price : Math.round(last.price * 0.85);
    var was = v.compare_at_price && v.compare_at_price > price ? v.compare_at_price : (sub ? v.price : 0);
    return {
      price: money(price), once: money(v.price), subp: money(subp),
      unit: money(price / pairs), subunit: money(subp / pairsOf(last.title)),
      was: was ? money(was) : '',
      save: was ? 'SAVE ' + Math.round((1 - price / was) * 100) + '%' : '',
      pack: String(v.title).toLowerCase(), third: money(price / 3),
      plan: p ? cap(planShort(p.name)) : '', planshort: p ? planShort(p.name) : '',
      yearsave: money(Math.round((12 / months) * (last.price - subp))),
      addLabel: null, _sub: !!sub, _v: v, _alloc: sub ? la : null
    };
  };
  var fill = function (el, vals) {
    var t = el.getAttribute('data-kv-t');
    if (!t) return;
    el.textContent = t.replace(/\{(\w+)\}/g, function (m, k) { return vals[k] != null ? vals[k] : ''; });
  };
  /* sections that share one buy box (e.g. the product page and its sticky bar) carry the same data-kv-buy key */
  var renderBuy = function (root) {
    var key = buyKey(root);
    if (!key) return renderOne(root);
    $$('[data-kv-root][data-kv-buy="' + key + '"]').forEach(renderOne);
  };
  var renderOne = function (root) {
    if (!product) return;
    var st = buyState(root);
    var vals = buyVals(st);
    $$('[data-kv-v]', root).forEach(function (el) {
      if (el.closest('[data-kv-l="packs"]')) return;
      fill(el, vals);
    });
    // per-pack prices
    $$('[data-kv="pick"][data-kv-l="packs"]', root).forEach(function (b) {
      var i = +b.getAttribute('data-kv-i');
      var v = product.variants[i];
      if (!v) return;
      var price = v.price;
      if (vals._sub && i === st.last && vals._alloc) price = vals._alloc.price;
      $$('[data-kv-v="per"]', b).forEach(function (el) {
        fill(el, { vprice: money(price), vunit: money(price / pairsOf(v.title)) });
      });
    });
    setRadio(root, 'packs', st.vi);
    setRadio(root, 'plans', vals._sub ? 1 : 0);
    // subscription is only offered on the largest pack: hide its option on any other pack
    var subOk = st.vi === st.last || root.getAttribute('data-kv-mode') === 'sub';
    $$('[data-kv="pick"][data-kv-l="plans"][data-kv-i="1"]', root).forEach(function (b) {
      b.hidden = !subOk; b.style.display = subOk ? '' : 'none';
    });
    setRadio(root, 'freqs', st.plan);
    // cross-sell: hide the upgrade once on the biggest pack
    $$('[data-kv="act"][data-kv-l="xsell"]', root).forEach(function (b) {
      var row = b.parentElement;
      if (+b.getAttribute('data-kv-i') === 0) row.hidden = st.vi === st.last;
      else b.textContent = vals._sub ? 'Selected' : 'Switch';
    });
  };

  /* ---------------------------------------------------------- radio groups (class swap) */
  var RAD = new WeakMap();
  var groupOf = function (root, list) { return $$('[data-kv="pick"][data-kv-l="' + list + '"]', root); };
  var isOn = function (b) {
    return ['aria-pressed', 'aria-selected', 'aria-checked'].some(function (a) { return b.getAttribute(a) === 'true'; });
  };
  var classMap = function (el) { return [el.className].concat($$('*', el).map(function (c) { return c.getAttribute('class') || ''; })); };
  var applyMap = function (el, m) {
    var kids = $$('*', el);
    if (kids.length + 1 !== m.length) { el.className = m[0]; return; }
    el.className = m[0];
    kids.forEach(function (c, i) { if (m[i + 1]) c.setAttribute('class', m[i + 1]); else c.removeAttribute('class'); });
  };
  var setRadio = function (root, list, idx) {
    var g = groupOf(root, list);
    if (!g.length) return;
    var key = root;
    var store = RAD.get(key) || {};
    if (!store[list]) {
      var on = g.filter(isOn)[0] || g[0];
      var off = g.filter(function (b) { return b !== on; })[0];
      store[list] = { on: classMap(on), off: off ? classMap(off) : null };
      RAD.set(key, store);
    }
    var t = store[list];
    g.forEach(function (b, i) {
      var sel = (+b.getAttribute('data-kv-i')) === idx || (isNaN(+b.getAttribute('data-kv-i')) && i === idx);
      if (t.off) applyMap(b, sel ? t.on : t.off);
      ['aria-pressed', 'aria-selected'].forEach(function (a) { if (b.hasAttribute(a)) b.setAttribute(a, sel ? 'true' : 'false'); });
    });
  };

  /* ---------------------------------------------------------- snapshots (dial, story viewer, carousels) */
  var SNAP = new WeakMap();
  var snapsOf = function (root) {
    if (!SNAP.has(root)) {
      var m = {};
      $$('script[data-kv-snap]', root).forEach(function (s) {
        try { var d = JSON.parse(s.textContent); d.idx = d.cur || 0; m[d.name] = d; } catch (e) { /* ignore */ }
      });
      SNAP.set(root, m);
    }
    return SNAP.get(root);
  };
  var applySnap = function (root, sp, i) {
    sp.idx = i;
    var row = sp.data[i] || {};
    Object.keys(row).forEach(function (k) {
      $$('[data-kv-v="' + k + '"]', root).forEach(function (el) { el.textContent = row[k]; });
      ['src', 'alt', 'aria-label', 'stroke-dasharray', 'cx', 'cy', 'style'].forEach(function (a) {
        $$('[data-kv-a-' + a + '="' + k + '"]', root).forEach(function (el) {
          if (a === 'style') el.setAttribute('style', row[k]); else el.setAttribute(a, row[k]);
        });
      });
    });
    if (sp.pick) setRadio(root, sp.pick, i);
    if (sp.name === 'uv') {
      $$('[data-kv-bar]', root).forEach(function (b, k) { b.style.background = k <= i ? '#FFFFFF' : 'rgba(255,255,255,0.35)'; });
    }
  };
  var stepSnap = function (root, handler) {
    var m = snapsOf(root);
    Object.keys(m).forEach(function (k) {
      var sp = m[k];
      if (sp.prev === handler || sp.next === handler) {
        var n = sp.data.length;
        var i = sp.idx + (sp.next === handler ? 1 : -1);
        i = sp.wrap ? (i + n) % n : Math.max(0, Math.min(n - 1, i));
        applySnap(root, sp, i);
      }
    });
  };

  /* ---------------------------------------------------------- accordions */
  var toggle = function (btn) {
    var box = btn.parentElement, panel = null;
    for (var d = 0; d < 5 && box; d++) {
      panel = box.querySelector('[data-kv-panel]');
      if (panel) break;
      box = box.parentElement;
    }
    if (!panel) return;
    var open = panel.hidden;
    var list = btn.getAttribute('data-kv-l');
    if (open && list) {
      var root = btn.closest('[data-kv-root]') || document;
      $$('[data-kv="toggle"][data-kv-l="' + list + '"]', root).forEach(function (o) { if (o !== btn) setToggle(o, false); });
    }
    setToggle(btn, open, panel);
  };
  var setToggle = function (btn, open, panel) {
    if (!panel) {
      var box = btn.parentElement;
      for (var d = 0; d < 5 && box && !panel; d++) { panel = box.querySelector('[data-kv-panel]'); box = box.parentElement; }
    }
    if (!panel) return;
    panel.hidden = !open;
    if (btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    $$('span[aria-hidden="true"]', btn).forEach(function (s) {
      if (s.textContent === '+' || s.textContent === '−') s.textContent = open ? '−' : '+';
    });
    if (/^tg\d/.test(btn.getAttribute('data-kv') || '')) btn.style.transform = open ? 'rotate(45deg)' : 'none';
  };

  /* ---------------------------------------------------------- gallery */
  var gallery = function (btn) {
    var group = btn.parentElement;
    var holder = group.parentElement;
    var main = null;
    while (holder && !main) {
      main = $$('img', holder).filter(function (im) { return !group.contains(im); })[0] || null;
      if (!main) holder = holder.parentElement;
    }
    var img = btn.querySelector('img');
    if (!main || !img) return;
    main.src = img.currentSrc || img.src;
    main.alt = (btn.getAttribute('aria-label') || '').replace(/^Show /, '');
    var contain = getComputedStyle(img).objectFit === 'contain';
    main.style.objectFit = contain ? 'contain' : 'cover';
    main.style.padding = contain ? '12%' : '0';
    main.style.objectPosition = '50% 30%';
  };

  /* ---------------------------------------------------------- FAQ page filter */
  var faqFilter = function (root) {
    var input = root.querySelector('input[type="search"]');
    var q = input ? input.value.trim().toLowerCase() : '';
    var st = buyState(root);
    var cat = st.cat || 'All';
    var shown = 0;
    $$('div[data-kv-cat]', root).forEach(function (it) {
      var okCat = cat === 'All' || it.getAttribute('data-kv-cat') === cat;
      var okQ = !q || it.textContent.toLowerCase().indexOf(q) !== -1;
      it.hidden = !(okCat && okQ);
      if (!it.hidden) shown++;
    });
    $$('h2[data-kv-cat]', root).forEach(function (h) {
      var c = h.getAttribute('data-kv-cat');
      h.hidden = !$$('div[data-kv-cat]', root).some(function (it) { return !it.hidden && it.getAttribute('data-kv-cat') === c; });
    });
    var none = root.querySelector('[data-kv-panel="none"]');
    if (none) none.hidden = shown > 0;
  };

  /* ---------------------------------------------------------- menus */
  var menu = document.getElementById('kv-menu');
  var mega = document.getElementById('kv-mega');
  var megaTimer = null;
  var showMega = function (a) {
    if (!mega) return;
    clearTimeout(megaTimer);
    var nav = a.closest('nav');
    mega.style.top = Math.max(0, nav.getBoundingClientRect().bottom) + 'px';
    mega.hidden = false;
  };
  var hideMega = function () { megaTimer = setTimeout(function () { if (mega) mega.hidden = true; }, 160); };
  var megaTrigger = function (a) {
    if (!mega || a.closest('#kv-menu') || a.closest('.kv-m') || a.closest('#kv-mega')) return false;
    var t = mega.getAttribute('data-trigger') || '/collections/all';
    return !!a.closest('nav[aria-label="Main"]') && a.getAttribute('href') === t;
  };
  /* delegated, so it keeps working after the theme editor re-renders the header or menu */
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && megaTrigger(a) && !a.contains(e.relatedTarget)) { showMega(a); return; }
    if (mega && e.target.closest && e.target.closest('#kv-mega')) clearTimeout(megaTimer);
  });
  document.addEventListener('mouseout', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && megaTrigger(a) && !a.contains(e.relatedTarget)) { hideMega(); return; }
    var m = e.target.closest && e.target.closest('#kv-mega');
    if (m && !m.contains(e.relatedTarget)) hideMega();
  });
  window.addEventListener('scroll', function () { if (mega && !(window.Shopify && window.Shopify.designMode)) mega.hidden = true; }, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    menu = document.getElementById('kv-menu');
    mega = document.getElementById('kv-mega');
  });

  /* ---------------------------------------------------------- clicks */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (a && !a.hasAttribute('data-kv')) {
      var href = a.getAttribute('href');
      if (href === '/cart' && document.getElementById('kv-cart') && !document.body.classList.contains('template-cart')) {
        e.preventDefault(); refreshCart(true); return;
      }
      if (href.charAt(0) === '#' && href.length > 1) {
        var t = visibleTarget(href.slice(1));
        if (menu && !menu.hidden && menu.contains(a)) { menu.hidden = true; document.documentElement.style.overflow = ''; }
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', href); }
        return;
      }
    }
    var el = e.target.closest('[data-kv]');
    if (!el) return;
    if (el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href').charAt(0) === '#') e.preventDefault();
    var h = el.getAttribute('data-kv');
    var root = el.closest('[data-kv-root]') || document;
    var list = el.getAttribute('data-kv-l');
    var i = +el.getAttribute('data-kv-i');
    var st, v;

    if (h === 'toggle' || /^tg\d$/.test(h)) { toggle(el); return; }
    if (h === 'menuopen' && menu) { menu.hidden = false; document.documentElement.style.overflow = 'hidden'; return; }
    if (h === 'menuclose' && menu) { menu.hidden = true; document.documentElement.style.overflow = ''; return; }
    if (h === 'search') { window.location.href = '/search'; return; }
    if (h === 'cartclose') { drawerClose(); return; }
    if (h === 'cartopen') { drawerOpen(); return; }

    if (h === 'pick') {
      var snaps = snapsOf(root);
      var snapHit = Object.keys(snaps).filter(function (k) { return snaps[k].pick === list; })[0];
      if (snapHit) { applySnap(root, snaps[snapHit], i); return; }
      if (list === 'thumbs' || list === 'gallery') { setRadio(root, list, i); gallery(el); return; }
      if (list === 'packs' && product) {
        st = buyState(root); st.vi = i; if (i !== st.last && root.getAttribute('data-kv-mode') !== 'sub') st.sub = false;
        renderBuy(root); return;
      }
      if (list === 'plans' && product) {
        st = buyState(root);
        if (i === 1 && st.vi !== st.last && root.getAttribute('data-kv-mode') !== 'sub') return;
        st.sub = i === 1; if (st.sub) st.vi = st.last;
        renderBuy(root); return;
      }
      if (list === 'freqs' && product) { st = buyState(root); st.plan = i; renderBuy(root); return; }
      if (list === 'cats' && root.querySelector('div[data-kv-cat]')) {
        st = buyState(root); st.cat = el.firstChild ? el.firstChild.textContent.trim() : 'All';
        setRadio(root, list, i); faqFilter(root); return;
      }
      setRadio(root, list, i);
      return;
    }
    if (h === 'act' && list === 'xsell' && product) {
      st = buyState(root);
      if (i === 0) { st.vi = st.last; } else { st.sub = true; st.vi = st.last; }
      renderBuy(root); return;
    }
    if (h === 'add' || h === 'buynow' || h === 'uvShop' || h === 'add6' || h === 'add15' || (h === 'act' && list === 'shown')) {
      if (!product) { window.location.href = '/collections/all'; return; }
      st = buyState(root);
      var vals = buyVals(st);
      v = vals._v; var plan = vals._alloc ? vals._alloc.selling_plan_id : null;
      if (h === 'add6') { v = product.variants[0]; plan = null; }
      if (h === 'add15') { v = product.variants[product.variants.length - 1]; plan = null; }
      if (h === 'act') { var vid = +el.getAttribute('data-kv-vid'); v = vid ? { id: vid } : (product.variants[i] || product.variants[0]); plan = null; }
      if (h === 'uvShop') closeViewer(root);
      busy(el, true);
      addItem(v.id, plan).then(function () {
        busy(el, false);
        if (h === 'buynow') { window.location.href = '/checkout'; return; }
        return refreshCart(true);
      }).catch(function (err) { busy(el, false); alert(err.message); });
      return;
    }
    if (h === 'open' && list === 'uvTiles') { openViewer(root, i); return; }
    if (h === 'uvClose') { closeViewer(root); return; }
    if (h === 'clear') {
      var inp = root.querySelector('input[type="search"]'); if (inp) inp.value = '';
      st = buyState(root); st.cat = 'All'; setRadio(root, 'cats', 0); faqFilter(root); return;
    }
    if (/Prev$|Next$/.test(h)) { stepSnap(root, h); return; }
    // cart drawer actions
    if (h === 'qty') {
      busy(el, true);
      post('/cart/change.js', { line: +el.getAttribute('data-line'), quantity: +el.getAttribute('data-qty') })
        .then(function () { return refreshCart(false); }).catch(function (err) { alert(err.message); refreshCart(false); });
      return;
    }
    if (h === 'upgrade' || h === 'plan') {
      busy(el, true);
      var line = +el.getAttribute('data-line'), id = +el.getAttribute('data-id');
      var q = +el.getAttribute('data-qty');
      var pl = el.getAttribute('data-plan');
      var first = h === 'upgrade' ? post('/cart/change.js', { line: line, quantity: q }) : post('/cart/change.js', { line: line, quantity: 0 });
      first.then(function () { return addItem(id, pl ? +pl : null, h === 'upgrade' ? 1 : q); })
        .then(function () { return refreshCart(false); }).catch(function (err) { alert(err.message); refreshCart(false); });
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-kv="onSearch"]')) faqFilter(e.target.closest('[data-kv-root]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) { menu.hidden = true; document.documentElement.style.overflow = ''; }
    var c = document.getElementById('kv-cart');
    if (c && !c.hidden && !document.body.classList.contains('template-cart')) drawerClose();
    $$('[data-kv-panel="uvOpen"]').forEach(function (p) { if (!p.hidden) closeViewer(p.closest('[data-kv-root]')); });
  });

  /* ---------------------------------------------------------- story viewer */
  var openViewer = function (root, i) {
    var sp = snapsOf(root).uv;
    var panel = root.querySelector('[data-kv-panel="uvOpen"]');
    if (!sp || !panel) return;
    applySnap(root, sp, i);
    panel.hidden = false;
  };
  var closeViewer = function (root) {
    var panel = root && root.querySelector('[data-kv-panel="uvOpen"]');
    if (panel) panel.hidden = true;
  };

  /* ---------------------------------------------------------- anchors across desktop / mobile */
  var visibleTarget = function (id) {
    var ids = [id, 'm-' + id, 'n-' + id];
    for (var k = 0; k < ids.length; k++) {
      var t = document.getElementById(ids[k]);
      if (t && t.offsetParent !== null) return t;
    }
    return null;
  };
  if (location.hash.length > 1) {
    window.addEventListener('load', function () {
      var t = visibleTarget(location.hash.slice(1));
      if (t) t.scrollIntoView();
    });
  }

  /* ---------------------------------------------------------- contact form success */
  if (/contact_posted=true/.test(location.search)) {
    $$('[data-kv-panel="sent"]').forEach(function (p) { p.hidden = false; });
    $$('form[id^="kv-contact-"]').forEach(function (f) { f.hidden = true; });
  }
  $$('[data-kv="again"]').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('[data-kv-panel="sent"]').forEach(function (p) { p.hidden = true; });
      $$('form[id^="kv-contact-"]').forEach(function (f) { f.hidden = false; });
    });
  });

  /* ---------------------------------------------------------- videos: always start muted */
  /* Every video starts muted when it plays. Once someone turns the sound on, that video keeps it,
     and any other video that is playing with sound is muted so only one is heard at a time. */
  var vids = function () { return $$('video'); };
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    if (!v.hasAttribute('data-kv8-sound')) { v.muted = true; return; }
    vids().forEach(function (o) { if (o !== v && !o.muted) o.muted = true; });
  }, true);
  document.addEventListener('volumechange', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    if (v.muted) { v.removeAttribute('data-kv8-sound'); return; }
    v.setAttribute('data-kv8-sound', '');
    vids().forEach(function (o) { if (o !== v && !o.muted) o.muted = true; });
  }, true);
  vids().forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });

  /* ---------------------------------------------------------- init */
  if (product) $$('[data-kv-root]').forEach(function (root) {
    if (root.querySelector('[data-kv-l="packs"], [data-kv-l="freqs"], [data-kv-v]')) {
      // honour ?variant= on the product page
      var m = location.search.match(/variant=(\d+)/);
      if (m) product.variants.forEach(function (v, k) { if (String(v.id) === m[1]) buyState(root).vi = k; });
      if (root.getAttribute('data-kv-mode') === 'sub') buyState(root).vi = buyState(root).last;
      renderBuy(root);
    }
  });
})();
